import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { store } from '@/redux/store';
import { router } from '@/routers/index.router';
import { ThemeProvider } from 'next-themes';
import { ToastContainer } from '@/components/ui/toast';

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
        <RouterProvider router={router} />
        <ToastContainer />
      </ThemeProvider>
    </Provider>
  );
}

export default App;
